import {Swiper} from "swiper";
import {FreeMode, Navigation, Pagination} from "swiper/modules";
import {gsap} from "gsap/gsap-core";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from 'gsap/SplitText'

gsap.registerPlugin(SplitText);

window.initImageWithTextSlider = (selector = '.js-image-with-text-slider') => {
  if ($(selector).length === 0) {
    return false;
  }

  $(selector).each(function () {
    if ($(this).hasClass('swiper-container-initialized')) {
      return false;
    }
    let parentElement = $(this).parent();
    let swiperNavPrev = parentElement.find('.swiper-nav-prev')[0];
    let swiperNavNext = parentElement.find('.swiper-nav-next')[0];
    let pagination = parentElement.find('.swiper-pagination')[0];
    new Swiper($(this)[0], {
      modules: [FreeMode, Navigation, Pagination],
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: pagination,
        type: "fraction",
      },
      navigation: {
        nextEl: swiperNavNext,
        prevEl: swiperNavPrev,
        lockClass: 'nothing',
      },
    });
  });
}

function toggleSwiper(swiperInstance) {
  if (window.innerWidth >= 1025) {
    swiperInstance.each(function () {
      if (swiperInstance[0].swiper) {
        swiperInstance[0].swiper.disable();
        swiperInstance[0].swiper.destroy(true, true);
      }
    });
  } else {
    initImageWithTextSlider();
  }
}

$(document).ready(() => {
  initImageWithTextSlider();
  let selector = $('.js-image-with-text-slider');
  if (selector.length !== 0) {
    window.addEventListener('resize', () => toggleSwiper(selector));
  }
})

function initSliderTitle() {

  // let sections = gsap.utils.toArray('.carousel-with-content-title');
  // sections.forEach(section => {
  //   const mySplitText = new SplitText(section, { type: "words,chars" });
  //   const chars = mySplitText.chars; //an array of all the divs
  //   chars.forEach((char, index) => {
  //     gsap.set(char, { opacity: 0, rotateX: '-95deg', translateY: '100%' });
  //
  //     ScrollTrigger.create({
  //       trigger: char,
  //       // markers: true,
  //       scrub: true,
  //       start: "top-=60% bottom",
  //       end: 'bottom top',
  //       once: true,
  //       onEnter: () => {
  //         gsap.to(char, { opacity: 1, rotateX: 0, translateY: 0, duration: 0.5, delay: index * 0.05 }) // Adjust the stagger delay as per your preference
  //       }
  //     })
  //   });
  // });
}

if ($('.carousel-with-content-title').length) {
  initSliderTitle()
}
